<template>
  <div>
    <v-col class="px-0">
      <fiche-header
          :hide-chevron="true"
          :show-search="false"
          :ressource="ressource"
          @back="back">
      </fiche-header>
    </v-col>
    <v-row class="fiche">
      <v-col class="col-12">
        <div class="section p-4">
          <v-data-table
              :headers="headers"
              no-data-text="Aucune donn�e"
              :height="listHeight"
              :items="items"
              :items-per-page="-1"
              :search="searchText"
              class="white module-list"
              :row-props="notifRowProps"
              disable-pagination
              fixed-header
              hide-default-footer
              :mobile-breakpoint="100"
              :custom-sort="customSort"
              @click:row="selectItem">
            <template #top>
              <v-row class="m-0">
                <v-col cols="8">
                  <v-row>
                    <v-col class="col">
                      <search-filter-input
                          :value="searchText"
                          @input-updated="onSearchTextUpdated"></search-filter-input>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>

            <template v-for="(item, index) in headers" #[`header.${item.value}`]>
              <div :key="index" style="display: flex; align-items: center; justify-content: space-between;">
                <div><span>{{ item.text }}</span></div>
                <v-icon class="sort-icon p-1" small>fas fa-arrow-up</v-icon>
                <data-table-filter
                    :header-value="item.value"
                    :column-config="getConfig(item.value)"
                    :current-filters="getFilters(item.value)"
                    @apply="applyFilters">
                </data-table-filter>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import SearchFilterInput from '@/framework/base/components/SearchFilterInput.vue';
import DataTableFilter from '@/framework/base/components/DataTableFilter.vue';
import Admin from '@/generated/classes/Admin';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import ListBase from '@/framework/base/components/ListBase';
import AdminInfo from '@/generated/classes/AdminInfo';
import {Fiches} from '@/generated/classes/AppSchema';
import Route from '@/extend/classes/Route';
import {RessourceFwkFiche} from '@/ressources/globalRessources';
import {FwkFiches} from '@/ressources/globalRessources';
import {NotifDefTypes} from '@/generated/classes/NotifDef';
import {defineComponent} from "vue";

export default defineComponent({
  components: {
    SearchFilterInput,
    DataTableFilter,
    FicheHeader
  },
  extends: ListBase,
  data() {
    const adminInfos: AdminInfo[] = [];

    return {
      listHeight: 'calc(100vh - 275px)',
      adminInfos
    };
  },
  computed: {
    headers() {
      return [
        {text: "Table", value: 'label', cellClass: '', sortable: true},
        {text: "Nombre", value: 'count', cellClass: '', sortable: true},
      ];
    },
    ressource() {
      return RessourceFwkFiche(FwkFiches.ADMINISTRATION);
    },
    items(): AdminInfo[] {
      return this.adminInfos;
    }
  },
  created(): void {
    this.loadTypes();
  },

  methods: {
    loadTypes(): Promise<boolean> {
      return new Promise((resolve) => {
        Admin.listTableInfo().then((infos: AdminInfo[]) => {
          this.adminInfos = infos;
          resolve(true);
        });
      });
    },
    selectItem(e: Event, row: unknown): void {
      const route = new Route();
      route.fiche = Fiches.ADMIN_TABLE;
      route.attribut = row.item;
      this.$emit('selectItem', route);
    },
    notifType(item: any): string {
      let res = '';
      if (item && item.notifDefType) {
        if (item.notifDefType == NotifDefTypes.ACTION) {
          res = 'action-bg';
        } else if (item.notifDefType == NotifDefTypes.INFO) {
          res = 'info-bg';
        }
      }
      return res;
    },
    notifRowProps({item}: { item: any }): Record<string, string> {
      return {class: this.notifType(item)};
    },
    customSort(items: any[], index: any, isDesc: any): any[] {
      if (index.length > 0) {
        items.sort((a, b) => {
          const current = this.getLabel(index[0], a[index[0]], a)
          const next = this.getLabel(index[0], b[index[0]], b);
          if (isDesc[0]) {
            return (current > next) ? -1 : 1;
          } else if (!isDesc[0]) {
            return (current > next) ? 1 : -1;
          }
          return 0;
        });
      }
      return items;
    },
    back(): void {
      this.$emit("back")
    }
  }
})


</script>
